import { otpService } from '../api-clients';

export const resendOtp = async (): Promise<string> => {
  const response = await otpService.resendOtpChallenge();
  const nextResendAt = response.metadata?.next_resend_at;

  if (!response.success || typeof nextResendAt !== 'string') {
    throw new Error('OTP resend was rejected');
  }

  return nextResendAt;
};
